<app-page-header
  class="header"
  coreActivitySection="Header"
  coreUserActivityClickTracking="CloseGiftCard"
  backButtonText="Back"
  [backSwipe]="backSwipeConfig"
  (click)="back.emit()"
/>
